module.exports = __webpack_public_path__ + "assets/img/lastBgm2x.71ecfe76.png";